"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinTariffSchema = exports.createFinTariffSchema = exports.finTariffShape = exports.finTariffTypeEnum = void 0;
const zod_1 = require("zod");
/**
 * Enterprise Architecture Handbook v1.0 (OP Billing Administration,
 * Module 3 — Tariff Categories / Rate Cards). This admin CRUD manages
 * only the `FinTariff` header as a DRAFT — the existing
 * `POST /financial/tariffs/:tariffId/activate` endpoint (Stage 5C.2,
 * frozen) owns the DRAFT→ACTIVE transition and versioning-on-supersede;
 * this schema deliberately excludes `status`/`versionNumber` so this
 * new CRUD cannot bypass that lifecycle.
 */
exports.finTariffTypeEnum = zod_1.z.enum(['GENERAL', 'CORPORATE', 'INSURANCE', 'VIP', 'BRANCH']);
exports.finTariffShape = {
    tariffCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    tariffType: exports.finTariffTypeEnum,
    payerId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid().optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.createFinTariffSchema = zod_1.z.object(exports.finTariffShape);
exports.updateFinTariffSchema = zod_1.z.object(exports.finTariffShape).partial();
//# sourceMappingURL=fin-tariff.schema.js.map